import { useEffect } from 'react';
const fonts = [];
const useFonts = (urls) => {
    useEffect(() => {
        for (const url of urls) {
            if (fonts.includes(url)) {
                continue;
            }
            const linkElement = document.createElement('link');
            linkElement.setAttribute('rel', 'stylesheet');
            linkElement.setAttribute('href', url);
            document.querySelector('head').appendChild(linkElement);
            fonts.push(url);
        }
    }, [urls]);
};
export default useFonts;
